import React from 'react';
import Header from '../Header';
import Footer from '../Footer';
import AdSlot from '../AdSlot';

/**
 * Shared shell for the Transportation / "Getting Around" info pages: header,
 * page title, the 2 reserved ad slots (top-left / top-right, per legacy
 * layout), content area and footer.
 */
const TransportPageLayout = ({ title, subtitle, adId, children }) => (
  <div className="min-h-screen bg-white">
    <Header />

    <main className="pt-28 pb-20 lg:pt-32">
      <div className="mx-auto max-w-5xl px-4">
        <header className="mb-8 text-center">
          <h1 className="text-3xl font-extrabold uppercase italic tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
            {title}
          </h1>
          {subtitle && <p className="font-script mt-2 text-2xl text-cyan-500 sm:text-3xl">{subtitle}</p>}
        </header>

        <div className="mb-10 flex items-start justify-between gap-4" data-testid={`${adId}-ad-row`}>
          <AdSlot id={`${adId}-left`} />
          <AdSlot id={`${adId}-right`} />
        </div>

        <div className="space-y-8" data-testid={`${adId}-content`}>
          {children}
        </div>
      </div>
    </main>

    <Footer />
  </div>
);

export default TransportPageLayout;
